import './App.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Status from './pages/Status';
import Maintenance from './pages/Maintenance';
import Feedback from './pages/Feedback';
import ThankYou from './pages/ThankYou';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Maintenance />} />
        <Route path='/status' element={<Status />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/test" element={<Feedback />} />
        <Route path="/thankyou" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
